'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagGqAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 20H28V13.3333H0V20Z",
          fill: "#EC3938"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 6.66667H28V0H0V6.66667Z",
          fill: "#51B422"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.6068 11.7151C13.6367 11.684 13.6535 11.6426 13.6537 11.5995L13.665 9.62741C13.6659 9.46527 13.5347 9.33333 13.3726 9.33333C13.1121 9.33333 12.9816 9.01837 13.1658 8.83417L13.7643 8.2357C13.8945 8.10553 14.1055 8.10553 14.2357 8.2357L14.8333 8.83333C15.0178 9.01785 14.8872 9.33333 14.6262 9.33333C14.4645 9.33333 14.3333 9.46447 14.3333 9.62623V11.5976C14.3333 11.6418 14.3509 11.6842 14.3821 11.7155C14.4871 11.8205 14.4128 12 14.2643 12H13.7282C13.5799 12 13.5041 11.8221 13.6068 11.7151Z",
          fill: "#159940"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 0L9.33333 10L0 20V0Z",
          fill: "#258DE7"
        }
      )
    ]
  }
);
const VpFlagGqAsset = forwardRef(FlagGqAsset);

export { VpFlagGqAsset as default };
